import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { TransportLocation } from '../models/transport-location.model';
import { TransportAlertTypeMap } from '../models/transport-alert-types';
import { getAlertColor, getAlertIcon } from '../utils';

export enum SegmentType {
  None = 0,
  Transport = 1,
  Stop = 2,
  Rest = 3,
  Other = 4
}

export interface TransportSegment {
  id: string;
  alertType: number;
  type: SegmentType;
  startTime: string | null;
  endTime: string | null;
  points: Array<TransportLocation>;
}

export class TransportSegment {
  uId: string;
  id: string; // id that comes in is the TransportHash, need to set a uId for UI tracking purposes
  type: SegmentType;
  path: google.maps.LatLng[];
  startDate: moment.Moment;
  endDate: moment.Moment;
  alertColor: string = '#0E6362';
  alertIcon: string = 'icon-small_solid_package-2';

  constructor(segment: TransportSegment) {
    Object.assign(this, segment);
    this.uId = uuid();

    const { points = [], startTime, endTime } = segment;

    this.startDate = moment(startTime);
    this.endDate = moment(endTime);
    this.path = points.map(({ lat, lng }) => new google.maps.LatLng({ lat, lng }));

    this.alertColor = getAlertColor(segment.alertType);
    this.alertIcon = getAlertIcon(segment.alertType);
  }
}
